import React from "react";
import { Timeslot } from "types";
import { AddonDisplay } from "../AddonDisplay";
import { GuideDisplay } from "../Resources/Guides/GuideDisplay";
import { InventoryDisplay } from "../Resources/InventoryDisplay";

export const GuideInventoryAddOnDisplay = ({ timeslot }: { timeslot: Timeslot }) => {
    return (
        <div className="flex min-w-72 items-center text-gray-darker lg:space-x-2">
            <GuideDisplay timeslot={timeslot} />
            <InventoryDisplay timeslot={timeslot} />
            <AddonDisplay purchasedAddon={timeslot.purchasedUnits?.merchandise} />
        </div>
    );
};
